import { FC, useEffect, useRef, useState } from 'react';
import { createChart, ISeriesApi } from 'lightweight-charts';
import styles from './styles.module.css';
import { Candle } from '../../../../utils/types';
import { Order } from '../../../../interfaces/token';
import { createCandles } from '../../../../utils/create-candles';

interface ChartComponentProps {
  orders: Order[];
  tokenPrice: number;
  loading: boolean;
  error: {
    error: string;
    message: string;
    statusCode: number;
  } | null;
}

export const ChartComponent: FC<ChartComponentProps> = (
  props: ChartComponentProps
) => {
  const { orders, loading, error, tokenPrice } = props;
  const [series, setSeries] = useState<ISeriesApi<'Candlestick', any> | null>(
    null
  );
  const [chart, setChart] = useState<any>(null);
  const [prices, setPrices] = useState<Array<Candle> | null>(null);
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chartRef.current) {
      const chart = createChart(chartRef.current, {
        width: chartRef.current.clientWidth,
        height: chartRef.current.clientHeight,
        timeScale: {
          timeVisible: true,
        },
        autoSize: true,
        layout: {
          background: {
            color: 'transparent',
          },
          textColor: '#fff',
        },
      });
      const series = chart.addCandlestickSeries({
        priceFormat: {
          type: 'price',
          precision: 10,
          minMove: 0.000_000_000_1,
        },
        upColor: '#00FF94',
        downColor: '#FC6868',
      });
      setSeries(series);
      setChart(chart);
    }
    return () => {
      if (chartRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        chartRef.current.innerHTML = '';
      }
    };
  }, [chartRef, loading, error]);

  useEffect(() => {
    if (!series || !prices?.length) {
      return;
    }
    series.setData(prices);
    chart.timeScale().fitContent();
  }, [prices, series]);

  useEffect(() => {
    if (!series || !orders?.length) {
      return; // loading
    }

    console.log({ orders });

    const prices = createCandles(
      orders,
      {
        duration: 60,
      },
      tokenPrice
    );

    setPrices(prices);
  }, [series, orders, tokenPrice]);

  return (
    <div className={styles.chartWrapper}>
      <div ref={chartRef} className={styles.chart} />
    </div>
  );
};
